import React from 'react';
export const useFocusOutside = (callback) => {
    const ref = React.useRef(null);
    React.useEffect(() => {
        const handleEvent = (e) => {
            if (ref.current && e.target instanceof Node && !ref.current.contains(e.target)) {
                callback();
            }
        };
        document.addEventListener('mousedown', handleEvent);
        document.addEventListener('focusin', handleEvent);
        return () => {
            document.removeEventListener('mousedown', handleEvent);
            document.removeEventListener('focusin', handleEvent);
        };
    }, [callback, ref]);
    return ref;
};
